var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.889 3.61091L30.889 3.6109C30.1188 2.84062 29.0955 2.42743 27.517 2.21521C25.9242 2.00106 23.8425 2 21 2H15C12.1574 2 10.0758 2.00106 8.48299 2.21521C6.90456 2.42743 5.88121 2.84061 5.11091 3.61091C5.11091 3.61091 5.11091 3.61091 5.11091 3.61091M30.889 3.61091L5.11091 3.61091M30.889 3.61091C31.6594 4.38121 32.0726 5.40456 32.2848 6.98299C32.4989 8.57581 32.5 10.6574 32.5 13.5V19.5C32.5 22.3425 32.4989 24.4242 32.2848 26.017C32.0726 27.5955 31.6594 28.6188 30.8891 29.389L30.889 29.3891C30.1188 30.1594 29.0955 30.5726 27.517 30.7848C25.9242 30.9989 23.8425 31 21 31H15C12.1574 31 10.0758 30.9989 8.48299 30.7848C6.90456 30.5726 5.88121 30.1594 5.11091 29.389L5.1109 29.389C4.34062 28.6188 3.92743 27.5955 3.71521 26.017C3.50106 24.4242 3.5 22.3425 3.5 19.5V13.5C3.5 10.6574 3.50106 8.57581 3.71521 6.98299C3.92743 5.40456 4.34061 4.38121 5.11091 3.61091M30.889 3.61091L5.11091 3.61091",
    fill: "white",
    stroke: "#8A91A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 10.75H22.5V11.875H23.25V10.75Z",
    fill: "#394D8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.125H22.5V10H23.25V8.125Z",
    fill: "#394D8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 11.125C23.2892 11.125 23.625 10.7892 23.625 10.375C23.625 9.96079 23.2892 9.625 22.875 9.625C22.4608 9.625 22.125 9.96079 22.125 10.375C22.125 10.7892 22.4608 11.125 22.875 11.125Z",
    fill: "#AEB7D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.82617V9.62492C15 10.4537 15.6712 11.1249 16.5 11.1249H19.5C20.3288 11.1249 21 10.4537 21 9.62492V8.82617L18 9.62492L15 8.82617Z",
    fill: "#9DA8C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.625L12.375 8.125L18 5.125L23.625 8.125L18 9.625Z",
    fill: "#394D8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26.125V16.375L18 11.875L22.5 16.375V26.125",
    fill: "#394D8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C19.0355 19 19.875 18.1605 19.875 17.125C19.875 16.0895 19.0355 15.25 18 15.25C16.9645 15.25 16.125 16.0895 16.125 17.125C16.125 18.1605 16.9645 19 18 19Z",
    fill: "#AEB7D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.625H9.375V26.125H13.5V18.625Z",
    fill: "#A2ADCD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.625 18.625H22.5V26.125H26.625V18.625Z",
    fill: "#A2ADCD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.125V23.125H19.5V26.125",
    fill: "#AEB7D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.375H27.375V18.625H22.5",
    fill: "#7983A3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.625H8.625V16.375H13.5",
    fill: "#7983A3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 26.125H6.75V26.875H29.25V26.125Z",
    fill: "#CACFDF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 23.125H17.625V26.125H18.375V23.125Z",
    fill: "#AEB7D0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C16.965 19 16.125 18.16 16.125 17.125C16.125 16.09 16.965 15.25 18 15.25",
    fill: "#AEB7D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolBuilding);
export default __webpack_public_path__ + "static/media/school_building.6c1b3475104c1d1c8b5b6731305d3407.svg";
export { ForwardRef as ReactComponent };